// CustomerSlice.js
import { createSlice } from '@reduxjs/toolkit';

const customerSlice = createSlice({
  name: 'customer',
  initialState: {
    list: [],
    selectedCustomer: {},
    isModalVisible: false,
    data:{},
  },
  reducers: {
    setCustomerList(state, action) {
      state.list = action.payload;
    },
    setSelectedCustomer(state, action) {
      state.selectedCustomer = action.payload;
    },
    setModalVisibility(state, action) {
      state.isModalVisible = action.payload;
    },
    clearSelectedCustomer(state) {
      state.selectedCustomer = null;
    },
    setServiceQuestionData(state, action) {
      state.data = action.payload;
    },
  },
});

export const { setCustomerList, setSelectedCustomer, setModalVisibility, clearSelectedCustomer, setServiceQuestionData  } = customerSlice.actions;
export default customerSlice.reducer;
